<div class="container my-5">
  <div class="wrapper__form__content row g-3">
    <div class="wrapper__headerComponent container my-3">
      <div class="row align-items-center">
        <div class="col-12 col-md-3"></div>
        <div class="col-12 col-md-6">
          <h2 class="text-center h3-tipografia-govco mb-0">
            {{ 'descarga-documentos.documentos' | translate }}
          </h2>
        </div>
      </div>
    </div>
    <div class="wrapper__contentComponent--expediente container my-3">
      <div class="contenedor-tabla w-100">
        <app-table
          [estiloEncabezado]="'height: auto !important;'"
          [datos]="listaDocumentos"
          [columnas]="columns"
          [multipleSelection]="true"
          [paginacion]="true"
          (selectedItemsChange)="handleSelectedItems($event)"
          [localFiltering]="true"
          [idColumn]="'id'">
        </app-table>
      </div>
    </div>
    <div class="text-center">
      <button
        class="btn-govco outline-btn-govco hvr-shrink"
        [disabled]="selectedItems.length === 0"
        (click)="downloadDocuments()"
        aria-label="Descargar documentos">
        {{ 'descargar' | translate }}
      </button>
    </div>
  </div>
</div>
